import { convertTimetoString } from "../../../helperFunction";
import css from "../Approvals/css/view-modal.module.css";

import { NotAvailable } from "./styles";
import { ProfessionalBodyData } from "./type";
import styles from "./css/styles.module.css";
import DocumentBar from "./DocumentBar";

interface ProfessionalBodyProps {
  data?: ProfessionalBodyData[];
}

const ProfessionalBody: React.FC<ProfessionalBodyProps> = ({ data = [] }) => {
  return (
    <div className={`${css.contentDiv} ${css.professionalD}`}>
      <p className={css.title}>Professional Body</p>
      {data?.length > 0 ? (
        <div style={{ overflowX: "auto" }}>
          <table>
            <tr className={styles.tableHead}>
              <th>Professional Name</th>
              <th>Membership Grade</th>
              <th>Election Date</th>
              <th>Uploaded Document</th>
            </tr>

            {data?.length > 0 &&
              data.map((eData: any, index: number) => (
                <tr key={index}>
                  <td>{eData.BodyName || "N/A"} </td>
                  <td>{eData.MembershipGrade || "N/A"} </td>
                  <td>
                    {convertTimetoString(eData.ElectionDate, 2) || "N/A"}{" "}
                  </td>
                  <td>
                    <DocumentBar
                      hideScoreIntegration={false}
                      docName={eData.BodyName}
                      documentUrl={eData.FileUrl}
                      onChange={() => {}}
                    />
                  </td>
                </tr>
              ))}
          </table>
        </div>
      ) : (
        <NotAvailable> Not Available</NotAvailable>
      )}
    </div>
  );
};

export default ProfessionalBody;